var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.85714C23.5 8.49383 22.3345 10.0733 20.2372 11.2718C18.1541 12.4621 15.2428 13.2143 12 13.2143C8.75718 13.2143 5.84595 12.4621 3.76279 11.2718C1.66548 10.0733 0.5 8.49383 0.5 6.85714C0.5 5.22046 1.66548 3.64099 3.76279 2.44253C5.84595 1.25215 8.75718 0.5 12 0.5C15.2428 0.5 18.1541 1.25215 20.2372 2.44253C22.3345 3.64099 23.5 5.22046 23.5 6.85714Z",
    fill: "#1A74CD",
    stroke: "#1A74CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 9.42859C23.169 12.8111 18.1194 15.4286 12 15.4286C5.88057 15.4286 0.830988 12.8111 0.0928406 9.42859C0.031565 9.70938 0 9.99545 0 10.2857C0 14.0728 5.37258 17.1429 12 17.1429C18.6274 17.1429 24 14.0728 24 10.2857C24 9.99545 23.9684 9.70938 23.9072 9.42859Z",
    fill: "#1A74CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 12.8572C23.169 16.2397 18.1194 18.8572 12 18.8572C5.88057 18.8572 0.830988 16.2397 0.0928406 12.8572C0.031565 13.138 0 13.424 0 13.7143C0 17.5014 5.37258 20.5715 12 20.5715C18.6274 20.5715 24 17.5014 24 13.7143C24 13.424 23.9684 13.138 23.9072 12.8572Z",
    fill: "#1A74CD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9072 16.2858C23.169 19.6683 18.1194 22.2858 12 22.2858C5.88057 22.2858 0.830988 19.6683 0.0928406 16.2858C0.031565 16.5666 0 16.8526 0 17.1429C0 20.93 5.37258 24.0001 12 24.0001C18.6274 24.0001 24 20.93 24 17.1429C24 16.8526 23.9684 16.5666 23.9072 16.2858Z",
    fill: "#1A74CD"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.380107c6.svg";
export { ForwardRef as ReactComponent };